/*
 * nc-shipping.js — keeps the shipping UI in sync with the live cart.
 * Drives the header van badge (cheapest shipping) + the PDP bar (next-goal nudge).
 * The cart-drawer overview re-renders with the cart section (Dawn), so it needs no JS.
 *
 * Free shipping is WEIGHT-based, matching the live delivery rates:
 *   relay pickup free at >= 3.5 kg, home delivery free at >= 6.5 kg.
 * cart.total_weight (Liquid) and cart.js total_weight are both grams.
 */
(function () {
  'use strict';

  var RELAY_FREE = 3500; // grams — relay pickup becomes free
  var HOME_FREE = 6500; // grams — home delivery becomes free
  var CHECK = '✓ ';

  // Relay is always the cheapest method, so the cheapest price is €3,90 until it turns free.
  // The word "Free" is translated in Liquid and passed through a data attribute.
  function cheapest(weight, van) {
    var free = (van && van.dataset.textFree) || 'Free';
    return weight >= RELAY_FREE ? free : '€3,90';
  }

  function render(cart) {
    var weight = cart.total_weight;
    var count = cart.item_count;

    var van = document.getElementById('nc-ship-van');
    var badge = document.querySelector('.nc-ship-van__badge');
    if (badge) badge.textContent = cheapest(weight, van);

    var pdp = document.querySelector('[data-nc-ship-pdp]');
    if (!pdp) return;

    if (count === 0) {
      pdp.classList.add('is-hidden');
      return;
    }
    pdp.classList.remove('is-hidden');

    var relayFree = weight >= RELAY_FREE;
    var homeFree = weight >= HOME_FREE;
    var pct = Math.min(100, Math.round((weight / HOME_FREE) * 100));

    var fill = pdp.querySelector('[data-nc-ship-fill]');
    if (fill) fill.style.width = pct + '%';
    pdp.classList.toggle('is-free', relayFree);

    var text = pdp.querySelector('[data-nc-ship-text]');
    if (text) {
      var d = pdp.dataset;
      if (homeFree) text.textContent = CHECK + (d.textHome || 'Free shipping unlocked');
      else if (relayFree) text.textContent = CHECK + (d.textRelay || 'Free relay pickup unlocked');
      else text.textContent = d.textMore || 'Add more for free relay pickup';
    }
  }

  function refresh() {
    fetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(render)
      .catch(function () {});
  }

  // Van icon click mirrors the cart icon (opens the cart drawer / cart).
  function bindVan() {
    var van = document.getElementById('nc-ship-van');
    if (!van || van.dataset.bound) return;
    van.dataset.bound = '1';
    van.addEventListener('click', function (e) {
      var bubble = document.getElementById('cart-icon-bubble');
      if (bubble && bubble !== van) {
        e.preventDefault();
        bubble.click();
      }
    });
  }

  function init() {
    bindVan();
    refresh();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined' && PUB_SUB_EVENTS.cartUpdate) {
    subscribe(PUB_SUB_EVENTS.cartUpdate, function () { refresh(); });
  }
})();
